export default __webpack_public_path__ + "static/media/small-mod3.ae386304.jpg";